import React from "react";
import { motion } from "framer-motion";
import { MessageCircle, Sparkles, Eye, Rocket } from "lucide-react";
import { useLang } from "../contexts/LanguageContext";

const ICONS = [MessageCircle, Sparkles, Eye, Rocket];

export default function HowWeWork() {
  const { t } = useLang();
  return (
    <section id="how" className="py-20 md:py-28 bg-white" data-testid="how-section">
      <div className="max-w-7xl mx-auto px-5 md:px-8 lg:px-12">
        <div className="text-center max-w-3xl mx-auto">
          <div className="text-xs font-semibold uppercase tracking-[0.22em] text-blue-600">{t.how.eyebrow}</div>
          <h2 className="font-display text-3xl md:text-5xl font-bold mt-3 text-slate-950">{t.how.title}</h2>
          <p className="text-slate-600 mt-4 text-base md:text-lg">{t.how.subtitle}</p>
        </div>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5">
          {t.how.steps.map((s, i) => {
            const Icon = ICONS[i];
            return (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 18 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: i * 0.08, duration: 0.5 }}
                className="group relative rounded-2xl bg-white border border-slate-200 p-6 hover:-translate-y-1 hover:shadow-xl hover:border-slate-300 transition-all duration-300"
                data-testid={`how-step-${i}`}
              >
                <div className="absolute top-4 right-5 font-display text-6xl font-bold text-slate-100 group-hover:text-blue-50 transition leading-none select-none">
                  0{i + 1}
                </div>
                <div className="relative">
                  <div className="w-11 h-11 rounded-xl bg-gradient-to-br from-blue-600 to-violet-600 flex items-center justify-center shadow-md shadow-blue-500/30">
                    <Icon className="w-5 h-5 text-white" />
                  </div>
                  <h3 className="font-display text-xl font-bold mt-5 text-slate-950">{s.t}</h3>
                  <p className="text-slate-600 mt-2 text-sm leading-relaxed">{s.d}</p>
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
